import { staticUrls } from '../../config/constants';
import 'CssFolder/components/image-grid.scss';

export default function ImageGridComponent() {
  
  let isInteractive = false;
  let onImageClick = () => { };

  let getSrcString = (src = '') => {
    return src.length > 0 ? src : staticUrls.imageUnavailable;
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onImageClick) {
        isInteractive = true;
        onImageClick = vnode.attrs.onImageClick;
      }
    },
    view: ({ attrs }) => {
      return m('.scs-image-grid', {
        class: isInteractive ? 'interactive' : '',
      },
        (!attrs.imageList || attrs.imageList.length == 0)
          ? 'No image'
          : [
            attrs.imageList.map(imgItem => [
              m('figure', {
                onclick: (e) => { onImageClick(imgItem.id); }
              },
                m('img', {
                  src: getSrcString(imgItem.src)
                }),
                // Future enhancement
                // m('figcaption', imgItem.caption)
              )
            ])
          ]
      )
    }
  }
}